import React, { useEffect } from 'react'
import { callNativeByParams, getUA } from '@penguin/utils'
const ua = getUA()
const LINKS = {
  card: 'https://shop104224478.m.youzan.com/wscgoods/detail/2x71gxx2m5apyms?scan=1&activity=none&from=kdt&qr=directgoods_4095985735&shopAutoEnter=1',
  zero: 'https://shop104224478.m.youzan.com/wscgoods/detail/1yj775fot80xi0p?scan=1&activity=none&from=kdt&qr=directgoods_4095984699&shopAutoEnter=1',
}

const StrategyLand = () => {
  useEffect(() => {
    document.title = '携手官方！伊利x胖乖联名奶卡上线'
  }, [])
  return (
    <div>
      <img
        className=' absolute top-0 left-0 w-full'
        src='//static.qiekj.com/static/web/image/gonglve_1719193118375.jpg'
        alt=''
      />
      <div className='relative flex flex-col items-center'>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.card,
              })
            } else {
              window.location.href = LINKS.card
            }
          }}
          className='rem:mt-[588px] w-full rem:h-[880px]'
        ></div>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.zero,
              })
            } else {
              window.location.href = LINKS.zero
            }
          }}
          className='rem:mt-[28px] w-full rem:h-[880px]'
        ></div>
      </div>
    </div>
  )
}

export default StrategyLand
